// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__12qUZ","title":"BackImages_title__1jc9w","images":"BackImages_images__2AGX2"};